import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helperNumbers from "../../../../../helpers/numbers";
import helperTime from "../../../../../helpers/time";

export default function AllGift() {
  const [allGifts, setAllGifts] = useState([]);

  useEffect(() => {
    getAllGift();
  }, []);

  const getAllGift = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllGift = await sendRequestGetAllGift();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetAllGift) {
      return;
    }
    setAllGifts(resultSendRequestGetAllGift);
  };

  const sendRequestGetAllGift = async () => {
    let headersRequest = getHeaderForRequest();
    let allGifts;
    try {
      allGifts = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/gift/manage",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allGifts.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateAllGifts = () => {
    return allGifts.map((gift, index) => {
      return (
        <tr>
          <td>{helperNumbers.toPersianNum(index + 1)}</td>
          <td>{helperNumbers.toPersianNum(gift.gif_id)}</td>
          <td className="number-finance">
            {helperNumbers.toPersianNum(
              helperNumbers.toFormatFinanceNumber(gift.gif_min_amount)
            )}
          </td>
          <td className="number-finance">
            {helperNumbers.toPersianNum(
              helperNumbers.toFormatFinanceNumber(gift.gif_max_amount)
            )}
          </td>
          <td>
            {helperNumbers.toPersianNum(
              helperNumbers.toFormatFinanceNumber(gift.gif_percent)
            )}
          </td>
          <td>
            {gift.gif_active ? (
              <span className="badge badge-success">فعال</span>
            ) : (
              <span className="badge badge-danger">غیر فعال</span>
            )}
          </td>
          <td>
            {helperNumbers.toPersianNum(
              helperTime.convertGregorianToJalali(gift.gif_created_at) +
                " " +
                gift.gif_created_at.split(" ")[1]
            )}
          </td>
          <td>
            {helperNumbers.toPersianNum(
              helperTime.convertGregorianToJalali(gift.gif_updated_at) +
                " " +
                gift.gif_updated_at.split(" ")[1]
            )}
          </td>
          <td>
            <div>
              <span>
                <Link
                  to={`/finance/manage/edit-gift/${gift.gif_id}`}
                  className="btn btn-success"
                >
                  <i className="fa fa-edit"></i>
                </Link>
              </span>
              <span className="px-2">
                <Link
                  to={`/finance/manage/gift/users-use/${gift.gif_id}`}
                  className="btn btn-primary"
                >
                  <i className="fa fa-info"></i>
                </Link>
              </span>
              <span>
                <Link
                  to={`/finance/manage/gift/log/${gift.gif_id}`}
                  className="btn btn-info"
                >
                  <i className="fa fa-history"></i>
                </Link>
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="all-gift" />
      <div className="content-wrapper">
        <section className="content-header pt-4 pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">لیست هدیه</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div>
                <div className="text-right">
                  <Link
                    to="/finance/manage/add-gift"
                    className="btn btn-success"
                  >
                    <span className="d-flex align-items-center">
                      <i className="fa fa-plus"></i>
                      <span className="pr-2">اضافه کردن هدیه</span>
                    </span>
                  </Link>
                </div>
                <div className="table-responsive pt-2">
                  <table className="table table-hilite tbl-td-white-space">
                    <thead>
                      <tr>
                        <td>#</td>
                        <td>شماره هدیه</td>
                        <td>حداقل مبلغ</td>
                        <td>حداکثر مبلغ</td>
                        <td>درصد هدیه</td>
                        <td>وضعیت</td>
                        <td>تاریخ ثبت</td>
                        <td>تاریخ بروزرسانی</td>
                        <td>عملیات</td>
                      </tr>
                    </thead>
                    <tbody>{allGifts.length > 0 && generateAllGifts()}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
